import {svgIconWrapper} from '../svg-icon-wrapper';

import FlagTriangleRegular from './flag-triangle-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <FlagTriangleRegular {...props} />;
}
SvgComponent.iconName = 'flagTriangleRegular';

export const FlagTriangleRegularIcon = svgIconWrapper(SvgComponent);
